export class ContractRenewalDTO {
    public numberOfUsers: number;
    public initialTerm: Date;
    public finalTerm?: Date;
    public value: number;
    public indexReadjustment: Text;

    constructor(sub?) {
        sub = sub || {};

        this.numberOfUsers = sub.numberOfUsers || 0;
        this.initialTerm = sub.initialTerm || new Date();
        this.finalTerm = sub.finalTerm || null;
        this.value = sub.value || 0;
        this.indexReadjustment = sub.indexReadjustment || null;
    }
}
